/**
 * The words the browser console shows once when a page starts (P1.9-T223): the game's build and world line, the
 * line inviting a reader of the console to test, and the editor's build line. `{build}` is a short commit and
 * `{world}` a world version. `devBuild` stands for a build made without a commit.
 */
export const BANNER = {
  game: "OdysseyTales · build {build} · world {world}",
  hiring: "Looking under the hood? We're hiring testers: https://orbithq.gg/odyssey",
  editor: "Daedalus · build {build}",
  devBuild: "dev",
} as const;
